module.exports = __webpack_public_path__ + "img/rock-icon.4ff27492.jpg";